import {
  createRouter,
  createWebHistory,
  createWebHashHistory,
} from "vue-router";

const routes = [
  {
    path: "/",
    name: "goPr",
    component: () => import("@/pages/goPr.vue"),
  },
  {
    path: "/feedBack",
    name: "feedBack",
    component: () => import("@/pages/feedBack.vue"),
  },
  {
    path: "/feedSuccessful",
    name: "feedSuccessful",
    component: () => import("@/pages/feedSuccessful.vue"),
  },
  {
    path: "/goMini",
    name: "goMini",
    component: () => import("@/pages/goMini.vue"),
    meta: {
      title: "泡泡玛特",
    },
  },
  {
    path: "/bricksVideo",
    name: "bricksVideo",
    component: () => import("@/pages/bricksVideo.vue"),
  },
  {
    path: "/viewVideo",
    name: "viewVideo",
    component: () => import("@/pages/viewVideo.vue"),
  },
  {
    path: "/goMiniSelfAfterSales",
    name: "goMiniSelfAfterSales",
    component: () => import("@/pages/goMiniSelfAfterSales.vue"),
    meta: {
      title: "泡泡玛特",
    },
  },
  {
    path: "/goMiniImAftersale",
    name: "goMiniImAftersale",
    component: () => import("@/pages/goMiniImAftersale.vue"),
    meta: {
      title: "泡泡玛特",
    },
  },
  {
    path: "/intelligentFormFill",
    name: "intelligentFormFill",
    component: () => import("@/pages/intelligentFormFill.vue"),
  },
  {
    path: "/eSign",
    name: "eSign",
    component: () => import("@/pages/eSign.vue"),
    meta: {
      title: "电子签名",
    },
  },
  {
    path: "/eSignPad",
    name: "eSignPad",
    component: () => import("@/pages/eSignPad.vue"),
    meta: {
      title: "电子签名",
    },
  },
  {
    path: "/eSign/success",
    name: "signSuccess",
    component: () => import("@/pages/success.vue"),
    meta: {
      title: "签署成功",
    },
  },
  {
    path: "/:pathMatch(.*)*",
    name: "notFound",
    component: () => import("@/pages/notFound.vue"),
    meta: {
      title: "页面不存在",
    },
  },
];

export default createRouter({
  history: createWebHistory(),
  routes,
});
